module.exports = __webpack_public_path__ + "static/img/4.ac2335f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/6/sp/4.png
// module id = oNog
// module chunks = 0